var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center d-flex align-center justify-center",staticStyle:{"max-width":"300px","min-width":"300px"},attrs:{"fluid":"","fill-height":""}},[_c('div',{staticClass:"Absolute-Center"})])}
var staticRenderFns = []

export { render, staticRenderFns }